import type { ContractStatus } from '@shared/types/contract';

export function isTerminalContractStatus(status: ContractStatus): boolean {
  return status === 'canceled' || status === 'expired';
}

export function allowedNextStatuses(current: ContractStatus): ContractStatus[] {
  if (isTerminalContractStatus(current)) return [];
  const all: ContractStatus[] = ['draft', 'active', 'canceled', 'expired'];
  return all.filter((s) => s !== current);
}

export function requiresReason(next: ContractStatus): boolean {
  return next === 'canceled';
}
